import { render, staticRenderFns } from "./aiNewsMobile.vue?vue&type=template&id=2b861e76&scoped=true"
import script from "./aiNewsMobile.vue?vue&type=script&lang=js"
export * from "./aiNewsMobile.vue?vue&type=script&lang=js"
import style0 from "./aiNewsMobile.vue?vue&type=style&index=0&id=2b861e76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b861e76",
  null
  
)

export default component.exports